import React, { useEffect, useState} from "react";
import { FormProvider, useForm } from "react-hook-form";
import { IFormUtilisateur } from "../../../models/interfaces/IFormUtilisateur";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import RadioInput from "../../../components/forms/RadioInput";
import { ModulesList, Type_Compte, civiliteList, typeCompteList, validationMode } from "../../../config/helpers";
import TextInput from "../../../components/forms/TextInput";
import PhoneInputField from "../../../components/forms/PhoneInputField";
import { Button } from "react-bootstrap";
//import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import SelectInput from "../../../components/forms/SelectInput";
import { ICompte } from "../../../models/interfaces/ICompte";
import { UtilisateurSchema } from "../../../models/schema/UtilisateurSchema";
import { useUpdateCompteModulesMutation } from "../../../redux/slice/api/FO/compteApi";
import { toast } from "react-toastify";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import CheckboxInput from "../../../components/forms/CheckBoxInput";
import { useNavigate } from "react-router-dom";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";


interface IProps {
    handleEnregistrer: (data: IFormUtilisateur) => void;
    Compte: ICompte | undefined;
    ReadOnlyServicePart:boolean;
    disableEmail: boolean;
    setCompte?: React.Dispatch<React.SetStateAction<ICompte | undefined>>;
    handleNomPrenom?: (value: string) => void;
  }


const UtilisateurInformationsPersonnel: React.FC<IProps> = ({handleEnregistrer,Compte,disableEmail,ReadOnlyServicePart,setCompte,handleNomPrenom}:IProps) => {
    
  const [activeModules, setActiveModules] = useState<number[]>([]);

  const navigate = useNavigate();
  const [
    CompteUpdateModules,
    {
    data : dataCompteUpdateModules,
    isSuccess: isSuccessUpdateModules,
    error: errorCompteUpdateModules,
    isLoading: isLoadingUpdateModules
  }] = useUpdateCompteModulesMutation();

  const handleToggle = async (moduleId:number) => {
    const updatedModules = activeModules.includes(moduleId)
      ? activeModules.filter((id) => id !== moduleId) // Désactiver le module
      : [...activeModules, moduleId]; // Activer le module

    setActiveModules(updatedModules); // Mise à jour locale
    await CompteUpdateModules(
      {
        IdCompte: Compte?.Id ?? -1,
        Modules: updatedModules
      }); // Envoi des modifications
  };


    const formMethodsUtilisateur = useForm<IFormUtilisateur>({
        mode: "all",
        reValidateMode: "onChange",
        resolver: yupResolver(UtilisateurSchema)
      });
        
      useEffect(() => {
        handleNomPrenom && handleNomPrenom((Compte?.Prenom ? Compte.Prenom : "") + (Compte?.Nom ? Compte.Nom + " " : ""));
        //if (Compte !== undefined) {
          setValueUtilisateur("IdCivilite", Compte?.IdCivilite ? Compte.IdCivilite : -1);
          setValueUtilisateur("Nom", Compte?.Nom ? Compte.Nom : "");
          setValueUtilisateur("Prenom", Compte?.Prenom ? Compte.Prenom : "");
          setValueUtilisateur("Email", Compte?.Email ? Compte.Email : "");
          setValueUtilisateur("Telephone", Compte?.Telephone ? Compte.Telephone : "");
          setValueUtilisateur("IdTypeCompte", Compte?.IdTypeCompte ? Compte.IdTypeCompte : Type_Compte.UtilisateurSociete);
          setValueUtilisateur("RecevoirCommunications", Compte?.RecevoirCommunications ? Compte.RecevoirCommunications : false);
          setValueUtilisateur("RecevoirCommunicationsPartenaires", Compte?.RecevoirCommunicationsPartenaires ? Compte.RecevoirCommunicationsPartenaires : false)
          setActiveModules(Compte?.Modules ?? []);
        //}
      }, [Compte])

      // setValue, setError, clearErrors,getValues
      const { handleSubmit:handleSubmitUtilisateur, setValue:setValueUtilisateur} = formMethodsUtilisateur;

      const onErrorUtilisateur = (errors: any) => {
        //
      };

 

      useEffect(() => {
        if (errorCompteUpdateModules !== undefined) {
            toast.warn("Les modifications n'ont pas été prises en compte");
            setActiveModules(Compte?.Modules ?? []); //initiale
          }
      }, [errorCompteUpdateModules])
  
      
        useEffect(() => {
          if (isSuccessUpdateModules && dataCompteUpdateModules?.Return_IdType_Message === Type_Return_Message.Validation) {
            toast.success("Les modifications ont bien été prises en compte.");
            if (dataCompteUpdateModules) {
              setActiveModules(dataCompteUpdateModules?.Compte?.Modules ?? []);
              setCompte && setCompte(dataCompteUpdateModules?.Compte);
            }
          } else if (isSuccessUpdateModules && dataCompteUpdateModules?.Return_IdType_Message === Type_Return_Message.Erreur) {
            if (dataCompteUpdateModules?.Return_Message !== "") {
              toast.warn(dataCompteUpdateModules?.Return_Message );
            } else {
              toast.warn("Les modifications n'ont pas été prises en compte");
            }
            setActiveModules(dataCompteUpdateModules?.Compte?.Modules ?? []);
            setCompte && setCompte(dataCompteUpdateModules?.Compte);
          }
        }, [isSuccessUpdateModules])
       

    return (
      <>
        <div className="row pt-3 pb-4">
          <div className="col col-md-10 offset-md-1 col-12 ">
              <FormProvider {...formMethodsUtilisateur}>
                  <form onSubmit={handleSubmitUtilisateur((data) => handleEnregistrer !== undefined && handleEnregistrer(data),onErrorUtilisateur)}>
                    <CpntForm>
                      <CpntFormSection pSectionLabel="Informations sur l’utilisateur">
                            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,6,6,6,6,6]}>
                              { 
                              <RadioInput
                              label="Civilité"
                              formName="IdCivilite"
                              ismandatory={true}
                              //defaultValue={watchedCivilite} 
                              options={civiliteList.map((civ) => {
                                return {
                                  id: civ.Id,
                                  name: civ.Libelle,
                                  value: civ.Id,
                                };
                              })}
                              // onchange={(e) => {
                              //  setValueUtilisateur("IdCivilite", Number(e.target.value));
                              // }}
                              />
                              }
                              {
                             <SelectInput
                                label="Type de compte"
                                formName="IdTypeCompte"
                                ismandatory={true}
                                disabled = {true}
                                options={typeCompteList.map((tc) => {
                                  return {
                                    Id: tc.Id,
                                    Libelle: tc.Libelle,
                                  };
                                })}

                              />
                              }
                            
                              <TextInput
                                label="Nom"
                                formName="Nom"
                                ismandatory={true}
                                validationStyle={validationMode.classic}
                                placeholder="Nom"
                              />
                              <TextInput
                                label="Prénom"
                                formName="Prenom"
                                ismandatory={true}
                                validationStyle={validationMode.classic}
                                placeholder="Prénom"
                              />
                              <PhoneInputField
                                label="Téléphone"
                                formName="Telephone"
                                ismandatory={true}
                                placeholder="Numéro de téléphone"
                              />
                               <TextInput
                                label="Email"
                                formName="Email"
                                validationStyle={validationMode.classic}
                                placeholder="Email"
                                disabled={disableEmail}
                              />
                              {/* <SelectInput
                                label="Secteur d'activité"
                                formName="IdSecteurActivite"
                                ismandatory={true}
                                options={civiliteList.map((civ) => {
                                  return {
                                    Id: civ.Id,
                                    Libelle: civ.Libelle,
                                    //defaultChecked: civ.Id,
                                  };
                                })}
                              /> */}
                            </CpntFormSectionContainer>
                            <>
                            {Compte !== null && Compte !== undefined && (
                                  <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12, 12]}>
                                    <CheckboxInput
                                      formName="RecevoirCommunications"
                                      label={`J'accepte de recevoir les communications du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                      options={[
                                        {
                                          name: "",
                                          value: "disabled",
                                          defaultChecked: "",
                                        },
                                      ]}
                                      labelRight={true}
                                    />
                                    <CheckboxInput
                                      formName="RecevoirCommunicationsPartenaires"
                                      label={`J'accepte de recevoir les communications des partenaires du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                      options={[
                                        {
                                          name: "",
                                          value: "disabled",
                                          defaultChecked: "",
                                        },
                                      ]}
                                      labelRight={true}
                                    />
                                  </CpntFormSectionContainer>
                                )}
                            </>
                           
                            {disableEmail ? (
                                  <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6]}>
                                    <Button
                                      onClick={() => navigate(`/modifierutilisateuremail/${Compte?.Id}`)}
                                      className="btn-secondary btn btn-primary col-12"
                                    >
                                      Modifier votre email
                                    </Button>

                                    <Button type="submit" className="btn-secondary col-12">
                                      Enregistrer
                                    </Button>
                                  </CpntFormSectionContainer>
                                ) : (
                                  <CpntFormSectionNavigation>
                                    <Button type="submit" className="btn-secondary col-12">
                                      Enregistrer
                                    </Button>
                                  </CpntFormSectionNavigation>
                                )}

                                      
                      </CpntFormSection>
                    </CpntForm>
                  </form>
                </FormProvider>
              </div>
          </div>
       <div className="row pt-1 pb-5">
       <div className="col col-md-5 offset-md-1 col-12 "> 
         <div className="card form-card">
           <div className="card-body form-container text-start">
           <div className="d-flex"><p className="h6lpe me-4"><b>Les services de l&apos;utilisateur</b></p></div>
           {
           ReadOnlyServicePart ?
           ModulesList.map((mod) => (
             <><span>{mod.Libelle}</span> : <b>{ Compte?.Modules?.find(mid => mid === mod.Id) ? <i style={{padding: "0px 5px"}} className="text-green">Actif</i> : <i style={{padding: "0px 5px"}} className="text-redlight">Inactif</i>}</b><br/></>
             ))
         :
         ModulesList.map((mod) => (
           <div key={mod.Id} className="form-check form-switch mb-2">
           <input
            className={`form-check-input`} //${activeModules.includes(mod.Id) ? "bg-green":"bg-grey"}`}
             type="checkbox"
             id={`module-${mod.Id}`}
             checked={activeModules.includes(mod.Id)}
             onChange={() => handleToggle(mod.Id)}
             disabled={isLoadingUpdateModules} 
           />
           <label className="form-check-label" htmlFor={`module-${mod.Id}`}>
             <span>{mod.Libelle}</span>
           </label>
         </div>
       ))
         }
           </div>
         </div>
       </div>
       {/* <div className="col col-md-5 col-12 "> 
         <div className="card form-card">
           <div className="card-body form-container text-start">
           <div className="d-flex"><p className="h6lpe me-4"><b>L&apos;Administrateur de l&apos;organisation</b></p></div>

           </div>
         </div>
       </div> */}
     </div>
        </>
        );
};

export default UtilisateurInformationsPersonnel;

